<template>
    <div v-if="body">
        <v-chip
            class="border border-opacity-25 flex-shrink-0"
            v-bind="$attrs"
            color="info"
            variant="flat"
            label
        >
            Custom Made For <strong class="ms-1">{{ body.name === ProductGarmentDefaultNameOnLabel ? 'YOU' : body.name }}</strong>
        </v-chip>
    </div>
</template>

<script lang="ts" setup>
    import type { UserBody } from '~/types';
    import { ProductGarmentDefaultNameOnLabel } from '~/constants';

    defineProps({
        body: {
            type: Object as PropType<Nilish<UserBody>>,
            default: null
        }
    });

    defineOptions({
        inheritAttrs: false
    });
</script>

<style lang="scss"></style>
